import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import data, {tableKeys} from '../../Data/AncillaryPricingData';
import styles, {ancillaryPricingStyles} from '../../Foundations/Utils/PDFUtils';

const suppliers: string [] = Object.keys(data).map((key: string ) => key);
const driverRows: string[] = [tableKeys.ADDITIONAL_DRIVER, tableKeys.UNDERAGE_SURCHARGE, tableKeys.PHL];
const extrasRows: string[] = [tableKeys.GPS, tableKeys.RF_SEAT, tableKeys.FF_SEAT, tableKeys.BOOSTER_SEAT];

const TableHeader: React.FC = () => (
    <View style={{...styles.row, fontSize: 5.5}}>
        <View style={ancillaryPricingStyles.leftHeader} />
        {
            suppliers.map((key: string, index: number) =>
                <View
                    style={{...ancillaryPricingStyles.col}}
                    key={index}>
                    <View style={{...ancillaryPricingStyles.baseTd, backgroundColor: '#DBDDE8'}}>
                        <Text style={{...styles.fontBold}}>{data[key].name}</Text>
                    </View>
                </View>
            )
        }
    </View>
);

interface ITableRowProps  {
    rows: string[]
}

const TableRows: React.FC<ITableRowProps> = (props) => {
    return <React.Fragment>
        {
            props.rows.map((rowName: string, rowKey: number) => (
                <View style={{...styles.row, alignItems: 'stretch', display: 'flex'}} key={rowKey}>
                    <View style={{...ancillaryPricingStyles.leftHeader, fontSize: 5.5}}>
                        <View style={{...ancillaryPricingStyles.baseTd, backgroundColor: '#DBDDE8'}}>
                            <Text style={{...styles.fontBold}}>{rowName}</Text>
                        </View>
                    </View>
                    {
                        suppliers.map((key: string, index: number) =>
                            <View
                                style={ancillaryPricingStyles.col}
                                key={index}>
                                <View style={{...ancillaryPricingStyles.baseTd, backgroundColor: '#F5F6FA', fontSize: 5.5}}>
                                    {
                                        typeof data[key].data[rowName].pricing !== 'undefined' &&
                                        <Text style={{...styles.fontBold}}>
                                            {data[key].data[rowName].pricing}
                                        </Text>
                                    }
                                    {
                                        typeof data[key].data[rowName].details !== 'undefined' &&
                                        <Text>
                                            {data[key].data[rowName].details}
                                        </Text>
                                    }
                                    {
                                        typeof data[key].data[rowName].pricing === 'undefined' &&
                                        typeof data[key].data[rowName].details === 'undefined' &&
                                        <Text>N/A</Text>
                                    }
                                </View>
                            </View>
                        )
                    }
                </View>
            ))
        }
    </React.Fragment>
}



const AncillaryPricing: React.FC = () => {
    return (
        <View>
            <Text style={{...styles.fontBold, ...ancillaryPricingStyles.heading}}>Ancillary pricing</Text>
            <Text style={{ fontSize: 8, marginTop: 10 }}>This data is obtained via car rental provider’s electronic XML connection where available. Where this data is not available via XML connection it is obtained manually by VroomVroomVroom from pricing published by the car rental provider.</Text>

            <View style={{...styles.fontBold, ...ancillaryPricingStyles.tableTitle, marginTop: 20}}>
                <Text>Driver</Text>
            </View>

            <View>
                <TableHeader />
                <TableRows rows={driverRows} />
            </View>

            <View style={{...styles.fontBold, ...ancillaryPricingStyles.tableTitle}}>
                <Text>Extras</Text>
            </View>

            <View>
                <TableHeader />
                <TableRows rows={extrasRows} />
            </View>
        </View>
    )
}

export default AncillaryPricing;
